import React from 'react';

const DashboardHeader = ({
  stageName,
  isWaving,
  onReferralClick,
  showReferralNotification,
  onFAQClick,
  onProfileClick,
  showProfile,
  onLogout
}) => {
  return (
    <>
      <style>
        {`
          @keyframes wave {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(-20deg); }
            50% { transform: rotate(10deg); }
            75% { transform: rotate(-10deg); }
            100% { transform: rotate(0deg); }
          }
          .wave-animation {
            display: inline-block;
            animation: wave 0.5s infinite;
          }
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateY(-10px); }
            5% { opacity: 1; transform: translateY(0); }
            90% { opacity: 1; transform: translateY(0); }
            100% { opacity: 0; transform: translateY(-10px); }
          }
          .animate-fade-in-out {
            animation: fadeInOut 10s ease-in-out forwards;
          }
          @keyframes pulse-blue {
            0% {
              box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5);
            }
            70% {
              box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
            }
          }
          .pulse-blue {
            animation: pulse-blue 2s infinite;
            background-color: #EBF5FF;
            border-color: #3B82F6;
            color: #3B82F6;
          }
        `}
      </style>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {stageName ? `Welcome, ${stageName}!` : 'Welcome!'}{' '}
            <span className={isWaving ? 'wave-animation' : ''}>
              <img
                src="https://em-content.zobj.net/source/apple/279/waving-hand_1f44b.png"
                alt="👋"
                className="inline-block w-8 h-8 align-text-bottom"
              />
            </span>
          </h1>
          <div className="space-y-2">
            <p className="text-gray-600 text-sm">Know a DJ who might be interested in working with us?</p>
            <button
              onClick={onReferralClick}
              className="group inline-flex items-center px-3 py-1.5 bg-primary/10 hover:bg-primary/20 text-primary text-sm font-medium rounded-full transition-all duration-400"
              title="Click to copy referral link"
            >
              <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
              Refer a DJ
              <svg className="w-4 h-4 ml-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
              </svg>
            </button>
          </div>
          {showReferralNotification && (
            <div className="fixed top-4 right-1 bg-gray-800 text-white px-4 py-3 rounded-lg shadow-lg text-sm animate-fade-in-out z-50">
              <div className="flex items-center mb-1">
                <svg className="w-4 h-4 mr-2 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4m0 0l-4 4m4-4H6" />
                </svg>
                <span className="font-medium">Link copied!</span>
              </div>
              <p className="text-gray-300 text-xs">
                Share this link with other DJs to apply to work with DJs at the Polls!
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-2 sm:gap-3 w-full sm:w-auto">
          <button
            onClick={onFAQClick}
            className="flex-1 sm:flex-initial inline-flex items-center justify-center px-2 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-200 shadow-sm"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            FAQs
          </button>
          <button
            onClick={onProfileClick}
            className={`flex-1 sm:flex-initial inline-flex items-center justify-center px-2 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-xl text-[13px] sm:text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-200 shadow-sm ${showProfile ? 'pulse-blue' : ''}`}
          >
            <svg className={`w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2 ${showProfile ? 'text-blue-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {showProfile ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              )}
            </svg>
            {showProfile ? 'Dashboard' : 'Profile'}
          </button>
          <button
            onClick={onLogout}
            className="flex-1 sm:flex-initial inline-flex items-center justify-center px-2 sm:px-4 py-2 sm:py-2.5 border border-transparent rounded-xl text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-200 shadow-sm"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Sign-out
          </button>
        </div>
      </div>
    </>
  );
};

export default DashboardHeader;
